import { requestApi } from '../util/network'

export const getGoodsList =
(params, other) =>
  requestApi(
    '/o2o_fuwu_manage_goods/get_list',
    'POST',
    Object.assign(
      {
        page: params.page,
        per_page: params.per_page
      },
      other),
    'fuwu'
  )
export const getGoodsInfo =
    (o2o_fuwu_goods_id) =>
      requestApi(
        '/o2o_fuwu_manage_goods/get_info',
        'POST',
        {
          o2o_fuwu_goods_id: o2o_fuwu_goods_id
        },
        'fuwu'
      )
export const editGoods =
    (o2o_fuwu_goods_id, goods, goods_body, spec_list) =>
      requestApi(
        '/o2o_fuwu_manage_goods/edit',
        'POST',
        {
          o2o_fuwu_goods_id: o2o_fuwu_goods_id,
          o2o_fuwu_goods_name: goods.o2o_fuwu_goods_name,
          o2o_fuwu_goods_advword: goods.o2o_fuwu_goods_advword,
          o2o_fuwu_goods_image: goods.o2o_fuwu_goods_image,
          o2o_fuwu_class_id: goods.o2o_fuwu_class_id,
          o2o_fuwu_goods_state: goods.o2o_fuwu_goods_state,
          o2o_fuwu_class_id_1: goods.o2o_fuwu_class_id_1,
          o2o_fuwu_class_id_2: goods.o2o_fuwu_class_id_2,
          o2o_fuwu_class_name: goods.o2o_fuwu_class_name,
          goods_body: JSON.stringify(goods_body),
          spec_list: JSON.stringify(spec_list)
        },
        'fuwu'
      )
export const addGoods =
    (goods, goods_body, spec_list) =>
      requestApi(
        '/o2o_fuwu_manage_goods/add',
        'POST',
        {
          o2o_fuwu_goods_name: goods.o2o_fuwu_goods_name,
          o2o_fuwu_goods_advword: goods.o2o_fuwu_goods_advword,
          o2o_fuwu_goods_image: goods.o2o_fuwu_goods_image,
          o2o_fuwu_class_id: goods.o2o_fuwu_class_id,
          o2o_fuwu_goods_state: goods.o2o_fuwu_goods_state,
          o2o_fuwu_class_id_1: goods.o2o_fuwu_class_id_1,
          o2o_fuwu_class_id_2: goods.o2o_fuwu_class_id_2,
          o2o_fuwu_class_name: goods.o2o_fuwu_class_name,
          goods_body: JSON.stringify(goods_body),
          spec_list: JSON.stringify(spec_list)
        },
        'fuwu'
      )
export const delGoods =
    (o2o_fuwu_goods_id) =>
      requestApi(
        '/o2o_fuwu_manage_goods/del',
        'POST',
        {
          o2o_fuwu_goods_id: o2o_fuwu_goods_id
        },
        'fuwu'
      )
export const showGoods =
    (o2o_fuwu_goods_id, o2o_fuwu_goods_state) =>
      requestApi(
        '/o2o_fuwu_manage_goods/show',
        'POST',
        {
          o2o_fuwu_goods_id: o2o_fuwu_goods_id,
          o2o_fuwu_goods_state: o2o_fuwu_goods_state
        },
        'fuwu'
      )
